/**
 * Enum of statuses when managing slots.
 */
export enum ManageSlotsStatus {
  Complete = 'complete',
  InProgress = 'inProgress',
  Ready = 'ready',
  Paused = 'paused'
}
